// Contacts are people, companies, and complexes in one table, so no single name
// field is reliably populated — imported PM and supplier rows often have no
// first/last name at all. Fall through the display fields in the order a human
// would read them rather than interpolating nulls into the UI.
export const contactDisplayName = (c) => {
    if (!c) return '(unnamed)';
    const fullName = [c.firstName, c.lastName].filter(Boolean).join(' ').trim();
    return fullName || c.displayName || c.companyName || '(unnamed)';
};
